function Accordion(accordionId, resetOnEveryClick = false) {

  this.accordion = document.getElementById(accordionId)
  this.accordionBtns = this.accordion.querySelectorAll('button')
  this.lastClickedId = null
  this.resetAllActive = resetOnEveryClick
  this.events = function() {
      this.init()
  }

  this.init = function() {

      for (let [index, btn] of this.accordionBtns.entries()) {

          let parentContainer = btn.closest('div') || null
          let msgContainer = parentContainer.getElementsByClassName('item-answer')[0] || null

          if (!parentContainer || !msgContainer) return null

          let childId = "msg-" + index

          msgContainer.id = childId
          msgContainer.setAttribute('aria-labelledby', `btn-${index}`)
          msgContainer.setAttribute('aria-controlledby', `btn-${index}`)


          btn.id = "btn-" + index
          btn.setAttribute("role", 'button')
          btn.setAttribute("aria-label", `${index + 1} of ${this.accordionBtns.length}`)
          btn.setAttribute("aria-expanded", false)
          btn.setAttribute("aria-controls", childId)
          btn.addEventListener('pointerup', this.handleClick.bind(this))
      }

  }


  this.handleActiveState = function(e) {
      let contentBox = e.target.nextElementSibling
      e.target.focus()
      e.target.setAttribute('aria-expanded', true)
      contentBox.setAttribute('aria-expanded', true)
      contentBox.style.height = contentBox.scrollHeight + 'px'

  }

  this.handleNotActiveState = function(e) {
      let contentBox = e.target.nextElementSibling
      e.target.blur()
      e.target.setAttribute('aria-expanded', false)
      contentBox.setAttribute('aria-expanded', false)
      contentBox.style.height = 0
  }

  this.handleClick = function(e) {
      //  this check exists so the panel isn't stuck
      //  when the resetOnClick mode is set to true

      if (e.target.id === this.lastClickedId) {
          this.lastClickedId = e.target.id
          if (e.target.classList.contains('active')) {
              e.target.classList.remove('active')
              this.handleNotActiveState(e)
          } else {
              e.target.classList.add('active')
              this.handleActiveState(e)
          }
          return
      }
      if (this.resetAllActive) {

          this.accordionBtns.forEach((btn) => {
              if (btn.classList.contains('active')) {
                  btn.classList.remove('active')
                  let contentBox = btn.closest('div').getElementsByTagName('div')[0]
                  contentBox.style.height = 0
              }
          })
      }
      if (this.lastClickedId !== e.target.id) {
          this.lastClickedId = e.target.id
          e.target.classList.toggle('active')

          if (e.target.classList.contains('active')) {
              this.handleActiveState(e)
          } else {
              this.handleNotActiveState(e)
          }
      }
  }
  this.events()
}